import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsx } from 'react/jsx-runtime';
import UITooltip from '@phx-husky/tooltip';
import { RTEText } from '@promo-platform/rte-text';
import { useState } from 'react';
var InfoIcon = function InfoIcon(_ref) {
  var isHover = _ref.isHover;
  var path = isHover ? 'M17.5,2A15.5,15.5,0,1,0,33,17.5,15.506,15.506,0,0,0,17.5,2Zm1.55,23.25h-3.1v-9.3h3.1Zm0-12.4h-3.1V9.75h3.1Z' : 'M15.95,9.75h3.1v3.1h-3.1Zm0,6.2h3.1v9.3h-3.1ZM17.5,2A15.5,15.5,0,1,0,33,17.5,15.506,15.506,0,0,0,17.5,2Zm0,27.9A12.4,12.4,0,1,1,29.9,17.5,12.416,12.416,0,0,1,17.5,29.9Z';
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31"
  }, {
    children: jsx("path", {
      id: "Path_567",
      "data-name": "Path 567",
      d: path,
      transform: "translate(-2 -2)"
    })
  }));
};
var convertRTEtoPlainText = function convertRTEtoPlainText(rteText) {
  return JSON.parse(rteText).blocks.map(function (_ref2) {
    var text = _ref2.text;
    return text;
  }).join('\n');
};
var Tooltip = function Tooltip(_ref3) {
  var text = _ref3.text,
    label = _ref3.label;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHover = _useState2[0],
    setIsHover = _useState2[1];
  return jsx("div", Object.assign({
    className: "pp-tooltip"
  }, {
    children: jsx(UITooltip, Object.assign({
      placement: "top-end",
      className: "pp-tooltip-window",
      title: jsx(RTEText, {
        text: text
      })
    }, {
      children: jsx("button", Object.assign({
        type: "button",
        onMouseEnter: function onMouseEnter() {
          return setIsHover(true);
        },
        onMouseLeave: function onMouseLeave() {
          return setIsHover(false);
        },
        className: "pp-tooltip__button",
        "aria-label": label || convertRTEtoPlainText(text)
      }, {
        children: jsx(InfoIcon, {
          isHover: isHover
        })
      }))
    }))
  }));
};
export { Tooltip };